module.exports = __webpack_public_path__ + "img/Avatar-44.fb46db96.svg";